import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Signin.css";
import M from "materialize-css";
// import jwt_decode from "jwt-decode";
import { baseLogin } from "../Config/Config";

export default function Signin() {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");


  const navigate = useNavigate();

  const data = {
    email: email,
    password: password,
  };

  const loginUser = () => {
    fetch(`${baseLogin}token/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status === 200) {
          M.toast({
            html: "Tizimga xush kelibsiz!",
            classes: "#00e676 green accent-3",
          });
          response.json().then((n) => {
            localStorage.setItem("access_token", n.access);
            localStorage.setItem("refresh_token", n.refresh);
          });
          navigate("/");
          window.location.reload();
        } else if (response.status === 401) {
          response.json().then((data) => {
            if (data.detail) {
              M.toast({
                html: data.detail,
                classes: "#00e676 red accent-3",
              });
            } else {
              M.toast({
                html: "Email yoki parol noto'g'ri!",
                classes: "#00e676 red accent-3",
              });
            }
          }).catch(() => {
            M.toast({
              html: "Email yoki parol noto'g'ri!",
              classes: "#00e676 red accent-3",
            });
          });
        } else {
          M.toast({
            html: "Xatolik yuz berdi!",
            classes: "#00e676 red accent-3",
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        M.toast({
          html: "Tarmoq xatosi!",
          classes: "#00e676 red accent-3",
        });
      });
  };

  return (
    <div className="signin">
      <div className="container">
        <div className="kirish">
          <div class="box">
            <div className="kirish-top">
              <h1>Kirish</h1>
            </div>
            <form>
              <input
                name="email"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                placeholder="Password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </form>
            <button className="btn" onClick={() => loginUser()}>
              Tizimga kirish
            </button>
            <div className="kirish-bottom">
            <Link to="/signup">
                Ro‘yxatdan o‘tish
              </Link>
            <Link className="send" to={"/send-email"}>
              Parolni unutdingizmi ?
            </Link>
              </div>

            {/* <div className="kirish-bottom">
              <a href="#" className="google">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.1712 8.36788H17.5V8.33329H9.99996V11.6666H14.7095C14.0225 13.607 12.1762 15 9.99996 15C7.23871 15 4.99996 12.7612 4.99996 9.99996C4.99996 7.23871 7.23871 4.99996 9.99996 4.99996C11.2745 4.99996 12.4341 5.48079 13.317 6.26621L15.6741 3.90913C14.1858 2.52204 12.195 1.66663 9.99996 1.66663C5.39788 1.66663 1.66663 5.39788 1.66663 9.99996C1.66663 14.602 5.39788 18.3333 9.99996 18.3333C14.602 18.3333 18.3333 14.602 18.3333 9.99996C18.3333 9.44121 18.2758 8.89579 18.1712 8.36788Z"
                    fill="#FFC107"
                  />
                  <path
                    d="M2.62744 6.12121L5.36536 8.12913C6.10619 6.29496 7.90036 4.99996 9.99994 4.99996C11.2745 4.99996 12.4341 5.48079 13.317 6.26621L15.6741 3.90913C14.1858 2.52204 12.1949 1.66663 9.99994 1.66663C6.79911 1.66663 4.02327 3.47371 2.62744 6.12121Z"
                    fill="#FF3D00"
                  />
                  <path
                    d="M10 18.3334C12.1525 18.3334 14.1084 17.5096 15.5871 16.17L13.008 13.9875C12.1432 14.6452 11.0865 15.0009 10 15C7.83255 15 5.99213 13.618 5.2988 11.6892L2.5813 13.783C3.96047 16.4817 6.7613 18.3334 10 18.3334Z"
                    fill="#4CAF50"
                  />
                  <path
                    d="M18.1713 8.36796H17.5V8.33337H10V11.6667H14.7096C14.3809 12.5902 13.7889 13.3972 13.0067 13.988L13.0079 13.9871L15.5871 16.1696C15.4046 16.3355 18.3333 14.1667 18.3333 10C18.3333 9.44129 18.2758 8.89587 18.1713 8.36796Z"
                    fill="#1976D2"
                  />
                </svg>
                Google bilan ro‘yxatdan o‘tish
              </a>
            
            </div> */}
              
          </div>
        </div>
      </div>
    </div>
  );
}
